import { useEffect } from 'react';
import { UseFormReset } from 'react-hook-form';
import { dayjs } from '../../utils';
import { FormData, OrderDetailsI } from './types';

const useLoadOrderDetailValues = (
  reset: UseFormReset<FormData>,
  orderDetails: OrderDetailsI
): void => {
  useEffect(() => {
    const {
      id,
      firstName,
      lastName,
      email,
      updatedAt,
      passportNumber,
      birthdate,
      referenceCode,
      barcodeNumber,
      testType,
      testCategory,
    } = orderDetails;
    reset({
      id,
      firstName,
      lastName,
      contactEmail: email,
      updatedAt,
      testType,
      testCategory,
      documentType: 'Passport',
      documentNumber: passportNumber,
      birthdateDay: dayjs(birthdate).format('D'),
      birthdateMonth: dayjs(birthdate).format('MMMM'),
      birthdateYear: dayjs(birthdate).format('YYYY'),
      referenceCode,
      barcodeNumber,
    });
  }, [orderDetails, reset]);
};

export default useLoadOrderDetailValues;
